import React, { useEffect, useRef, useState  } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown, DropdownButton, ButtonGroup } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import PrintModal from '../../../modal/Purchase_Management/Manage_Purchase/PrintModal'
import axios from 'axios';
import StockPurchase from '../../../modal/Purchase_Management/Manage_Purchase/StockPurchase';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
const Purchase = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    // Purchase Status Label  
    const getPurchaseStatusLabel = (status) => {
    switch (parseInt(status)) {
        case 0: return "Generated";
        case 1: return "Waiting for Receive"; 
        case 2: return "Material Received"; 
        case 3: return "Partial Verified";
        case 4: return "Verified";
        case 5: return "Material Stocked";
        case 7: return "Payment Completed";
        case 8: return "Material Stocked";
        default: return "Unknown";
    }
    };

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            // ✅ Clear location state so it doesn't show again on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    // Badge color mapping
    const getPurchaseBadgeVariant = (status) => {
    switch (parseInt(status)) {
        case 0: return "success";     // Green
        case 1: return "warning";     // Orange
        case 2: return "primary";     // Blue
        case 3: return "secondary";   // Purple
        case 4: return "success";     // Dark Green
        case 5: return "info";        // Teal
        case 7: return "dark";   
        case 8: return "info";     // Cyan/Blue-Black
        default: return "dark";
    }
    };

    const getNextPurchaseStatusOptions = (currentStatus) => {
    switch (parseInt(currentStatus)) {
        case 0: return [1]; // Generated → Waiting for Receive
        case 1: return [2]; // Waiting for Receive → Material Received
        case 5: return [];  // Material Stocked → No next status (changed)
        default: return []; // Others → No next status
    }
    };

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");

    const tableRef = useRef(null);  


    const [showPrintModal, setShowPrintModal] = useState(false);
    const [selectedSno, setSelectedSno] = useState(null);

    const handleModalToggle_view = (sno) => {
    setSelectedSno(sno);
    setShowPrintModal(true);
    };

 
    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(10); //pagination
    const [managePurchase, setManagePurchase] = useState([]); //new list
    const [hasFetched, setHasFetched] = useState(false); 
   
    const fetchManagePurchase = async (pageNumber = 1, perPageCount = 25, search = '') => {
        try {
            const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
            
            const params = {
                page: pageNumber,
                per_page: perPageCount,
                search: search,
            };

            if (!isNaN(branch_id)) {
                params.branch_id = branch_id; // make sure it's "branch_id" not "bracnh_id"
            }

            const response = await axios.get(`${baseURL}/purchases`, { params });

            const data = response.data;
            setManagePurchase(data.data || []);
            setHasFetched(true);
        } catch (error) {
            console.error('Error fetching purchases:', error);
        }
    };

    useEffect(() => {
        fetchManagePurchase(page, perPage, searchTerm);
    }, [page, searchTerm, perPage]);
        
    useEffect(() => {
        const $table = $(tableRef.current); 
            
        // 🧹 Destroy existing DataTable instance if it exists
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $table.DataTable().clear().destroy();
        }
            
          if (managePurchase.length > 0) {  
                $table.DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":  
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            } 

            // 🔚 Clean up on unmount
            return () => {
                if ($.fn.dataTable.isDataTable(tableRef.current)) {
                    $table.DataTable().destroy();
                }
            };
    }, [managePurchase]);

    const [selectedPurchaseId, setSelectedPurchaseId] = useState(null); // <-- add this
    const handleModalToggleStock = (purchaseId) => {
        setModalType("StockPurchase");
        setOpen(true);
        setSelectedPurchaseId(purchaseId); // pass purchaseId to modal
    };

    const handlePurchaseStatusChange = (sno, newStatus) => {
    swal.fire({
        html: `
        <div class="alert alert-success px-2 py-2 mb-2" role="alert">
            Are you sure you want to change the status?
        </div>
        <div class="text-center mt-3 mb-2">
            <label class="fw-bold text-dark fs-5">${getPurchaseStatusLabel(newStatus)}</label>
        </div>
        `,
        showCancelButton: true,
        confirmButtonText: "✅ Yes, Update",
        cancelButtonText: "❌ Cancel",
        reverseButtons: true,
        customClass: {
        cancelButton: "btn btn-sm btn-secondary",
        confirmButton: "btn btn-sm btn-success",
        htmlContainer: "text-left"
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((result) => {
        if (result.isConfirmed) {
        axios
            .post(`${baseURL}/purchases/update/${sno}`, { purchase_status: newStatus }) // use PUT
            .then((res) => {
            swal.fire("✅ Updated!", "Purchase status updated successfully.", "success");
            fetchManagePurchase(); // refresh list
            })
            .catch((err) => {
            swal.fire("❌ Error!", err.response?.data?.message || "Failed to update purchase status.", "error");
            console.error("Purchase status update error:", err);
            });
        }
    });
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchManagePurchase();
    }

    return (
        <>
            
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">

  {open && modalType === "StockPurchase" && (
    <StockPurchase
      show={open}
      onClose={() => setOpen(false)}
      purchaseId={selectedPurchaseId}
      refresh={softRefresh}
    /> 
  )}

  {/* Left side: Title & Breadcrumb */}
  <div className='mb-2'>
    <div className="mb-0 px-0">
      <h4 style={{ color: '#025d3a' }}>Manage Purchase</h4>
    </div>
    <ol className="breadcrumb fs-7 mb-0">
      <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
      <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
      <li className="breadcrumb-item active">Purchase Management</li>
    </ol>
  </div>
  <div className='d-inline-flex align-items-center mt-1'>
        <label
          className="py-3 px-3 text-danger rounded-2"
          style={{
            border: '1px solid #D95B5B',
            backgroundColor: '#ffe5e5',
            borderRadius: '10px',
            width: '25px',
            height: '25px',
            marginRight: '0.25rem',
          }}
        ></label>
        <label className="fw-semibold text-black fs-6">Quantity Missing</label>
      </div>
    </div>
  {/* Right side: Buttons + Color indicator below */}
  <div className='text-end'>
    <div className='mb-1'>
      <Link to={"/auto-purchase"} className="btn btn-primary btn-sm me-2">
        Auto Purchase
      </Link>
      <Link to={"/add-purchase"} className="btn btn-primary btn-sm">
        Generate Purchase
      </Link>
    </div>

    {/* Color indicator BELOW buttons, right aligned */}
    

</div>


            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={75}>75</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Purchase ID / Date</th>
                            <th className='min-w-150px text-center'>
                                Vendor / <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Raw Material Count</span></Tooltip>} >
                                            <span> RMC </span>
                                        </OverlayTrigger> / Staff
                            </th>
                            <th className='min-w-50px'>Score</th>
                            <th className='min-w-150px  text-end'>Estimation Cost</th>
                            <th className='min-w-100px  text-end'>Actual Cost</th>
                            <th className='min-w-100px  text-center'>Status</th>
                            <th className='min-w-100px text-center'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {Array.isArray(managePurchase) &&
                          managePurchase.map((purchase, idx) => (
                            <tr key={purchase.sno}
                             style={{
                                backgroundColor: purchase.raw_material?.some(item => item.is_pending)
                                    ? '#ffe5e5' // light red color
                                    : 'transparent'
                                }}
                            >
                                <td>
                                    <label className='text-black font-w600 fs-7'>{purchase.purchase_id}</label>
                                    <div className='d-block'>
                                        <label className='text-primary font-w600 fs-7'>{formatDate(purchase.purchase_date)}</label>
                                    </div>
                                </td> 
 

                                <td className='text-center'>
                                    <label className='text-black fs-7 font-w600 me-2'>{purchase.vendor_businessname}</label>
                                    <Badge bg="info" className='text-white fs-7 rounded-pill'>{purchase.no_of_rawmaterial}</Badge>
                                    <div className='d-block'>
                                        <Badge bg="warning" className='text-white fs-7 rounded-pill'>{purchase.purchase_staffname}</Badge>
                                    </div>
                                </td>
                                   <td>
                                    <label
                                        className="text-black font-w600 fs-7 px-2 py-1 rounded"
                                        style={{
                                        backgroundColor:
                                            purchase.vendor_score === 100 ? '#d4edda' : '#f8d7da', // light green or light red
                                        color: purchase.vendor_score === 100 ? '#155724' : '#721c24', // dark text
                                        border:
                                            purchase.vendor_score === 100 ? '1px solid #28a745' : '1px solid #dc3545', // border color
                                        display: 'inline-block',
                                        minWidth: '60px',
                                        textAlign: 'center',
                                        fontWeight: '600', // bold
                                        }}
                                    >
                                        {purchase.vendor_score == null
                                        ? '000'
                                        : purchase.vendor_score === 100
                                        ? purchase.vendor_score
                                        : `-${purchase.vendor_score}`}
                                    </label>
                                    </td>

                           
                                <td align='right'>
                                    <label className='text-black font-w600  fs-4 py-0 px-1'> 
                                        <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span> 
                                        <span>
                                        {purchase.estimate_amount != null 
                                            ? purchase.estimate_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                            : '0.00'}
                                        </span>
                                         
                                    </label> 
                                </td>
                                
                                <td align='right'>
                                    <label className='text-black font-w600  fs-4 py-0 px-1'> 
                                        <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span> 
                                        {/* <span>{purchase.actual_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                                        <span>
                                        {purchase.actual_amount != null 
                                            ? purchase.actual_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                            : '0.00'}
                                        </span>
                                    </label> 
                                </td>

                           

                                <td className="text-center">
                                    {(() => {
                                        const rawStatus = purchase.purchase_status;
                                        const parsedStatus = parseInt(rawStatus);
 
                                        if ([0, 1].includes(parsedStatus)) {
                                            return (
                                                <Dropdown>
                                                <Dropdown.Toggle as="a" className="cursor-pointer py-2">
                                                    <Badge
                                                    bg={getPurchaseBadgeVariant(parsedStatus)}
                                                        style={{
                                                            color: "white",
                                                            padding: "4px 8px",
                                                            fontSize: "0.75rem",
                                                        }}
                                                    >
                                                    {getPurchaseStatusLabel(parsedStatus)}
                                                    </Badge>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {getNextPurchaseStatusOptions(parsedStatus).map((status) => (
                                                    <Dropdown.Item
                                                        key={status}
                                                        onClick={() => handlePurchaseStatusChange(purchase.sno, status)}
                                                    >
                                                        {getPurchaseStatusLabel(status)}
                                                    </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                                </Dropdown>
                                            );
                                        }

                                        // For all other statuses → just show badge
                                        return (
                                        <Badge
                                            bg={getPurchaseBadgeVariant(parsedStatus)}
                                            style={{
                                            color: "white",
                                            padding: "4px 8px",
                                            fontSize: "0.75rem",
                                            }}
                                        >
                                            {getPurchaseStatusLabel(parsedStatus)}
                                        </Badge>
                                        );
                                    })()}
                                </td>


               
                                <td className="text-end">
                                    <span className='d-flex align-items-center justify-content-center'>

                                      {/* Move to Stock */}
                                      {purchase.purchase_status === 4 && (
                                        <OverlayTrigger
                                          trigger={['hover', 'focus']}
                                          placement="bottom"
                                          overlay={
                                            <Tooltip className="toltip-popover">
                                              <span className="fs-8 text-white fw-semibold">Move to Stock</span>
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                            onClick={() => handleModalToggleStock(purchase.sno)}
                                          >
                                            <i className="fa-solid fa-boxes-stacked fs-5 mt-1"></i>
                                          </Button>
                                        </OverlayTrigger>
                                      )}

                                      {/* Bills */}
                                      {Number(purchase.purchase_status) === 4 && purchase.bill?.length > 0 && (
                                        <>
                                          {purchase.bill.map((bill, index) => (
                                            <OverlayTrigger
                                              key={bill.bill_id}
                                              trigger={['hover', 'focus']}
                                              placement="bottom"
                                              overlay={
                                                <Tooltip className="toltip-popover">
                                                  <span className="fs-8 text-white fw-semibold">Bill {index + 1}</span>
                                                </Tooltip>
                                              }
                                            >
                                              <a href={bill.url} target="_blank" rel="noopener noreferrer" download>
                                                <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                  <i className="fa-solid fa-receipt fs-5 mt-1"></i>
                                                </Button>
                                              </a>
                                            </OverlayTrigger>
                                          ))}
                                        </>
                                      )}

                                      {/* Print Purchase List */}
                                      {(purchase.purchase_status === 0 || purchase.purchase_status === 1 || purchase.purchase_status === 2 || purchase.purchase_status === 3) && (
                                        <OverlayTrigger
                                          trigger={['hover', 'focus']}
                                          placement="bottom"
                                          overlay={
                                            <Tooltip className='toltip-popover'>
                                              <span className='fs-8 text-white fw-semibold'>Print Purchase List</span>
                                            </Tooltip>
                                          }
                                        >
                                          <Link to={`/overall-print-page?data=${purchase.sno}`}>
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                              <i className="fa-solid fa-print fs-5 mt-1"></i>
                                            </Button>
                                          </Link>
                                        </OverlayTrigger>
                                      )}

                                      {/* Purchase Verification */}
                                      {(purchase.purchase_status === 2 || purchase.purchase_status === 3) && (
                                        <OverlayTrigger
                                          trigger={['hover', 'focus']}
                                          placement="bottom"
                                          overlay={
                                            <Tooltip className='toltip-popover'>
                                              <span className='fs-8 text-white fw-semibold'>Purchase Verification</span>
                                            </Tooltip>
                                          }
                                        >
                                          <Link to={`/amt-entry-purchase?data=${purchase.sno}`}>
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                              <i className="fa-solid fa-square-check fs-5 mt-1"></i>
                                            </Button>
                                          </Link>
                                        </OverlayTrigger>
                                      )}

                              
 
                                  <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <span className="fs-8 text-white fw-semibold">
                                          {purchase.raw_material?.some(item => item.is_pending) ? "Pending Items!" : "View"}
                                        </span>
                                      </Tooltip>
                                    }
                                  >
                                    <div className="position-relative d-inline-block">
                                      <Link to={`/view-purchase?data=${purchase.sno}`}>
                                        <Button
                                          variant="light"
                                          className="tp-btn-light px-2 py-1 me-1"
                                        >
                                          <i className="fa-solid fa-eye fs-5 mt-1 text-primary"></i>
                                        </Button>
                                      </Link>

                                      {/* Blinking exclamation mark */}
                                      {purchase.raw_material?.some(item => item.is_pending) && (
                                        <span
                                          className="position-absolute top-0 start-75 translate-middle-x"
                                          style={{
                                            animation: 'blink 1s infinite',
                                            WebkitAnimation: 'blink 1s infinite',
                                            fontSize: '0.9rem',
                                            fontWeight: 'bold',
                                            color: 'red',
                                          }}
                                        >
                                          !
                                        </span>
                                      )}
                                    </div>
                                  </OverlayTrigger>





                                      {/* Edit */}
                                      {(purchase.purchase_status === 0 || purchase.purchase_status === 1) && (
                                        <OverlayTrigger
                                          trigger={['hover', 'focus']}
                                          placement="bottom"
                                          overlay={
                                            <Tooltip className="toltip-popover">
                                              <span className="fs-8 text-white fw-semibold">Edit</span>
                                            </Tooltip>
                                          }
                                        >
                                          <Link to={`/edit-purchase?data=${purchase.sno}`}>
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                              <i className="fa-solid fa-pen-to-square fs-5 mt-1 primary"></i>
                                            </Button>
                                          </Link>
                                        </OverlayTrigger>
                                      )}

                                 

                                    </span>
                                  </td>

 
                            </tr>
                        ))}
                    </tbody>
                </table>
                    
                <PrintModal show={showPrintModal} onClose={() => setShowPrintModal(false)} sno={selectedSno}/>


                <div className="d-flex justify-content-between align-items-center mt-3"> 
                    <div>
                        {managePurchase.length > 0 && (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + managePurchase.length} of {totalPages * perPage - (perPage - managePurchase.length)} entries
                            </span>
                        )}
                    </div> 
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>

            <style>
                {`
                .required {
                    color: red;
                    margin-left: 2px;
                    font-weight: bold;
                }
                .datepicker-wrapper .rmdp-picker {
                    width: 100%;
                }
                .text-danger {
                    color: red;
                    font-size: 0.85rem;
                    margin-top: 2px;
                    display: block;
                }
                `}
            </style>
        </>
    )


}
export default Purchase;